import { useMutation, useQuery } from "@apollo/client";
import {
  Box,
  Button,
  Card,
  IconButton,
  Modal,
  OutlinedInput,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { addMinutes, format, isToday } from "date-fns";
import "../../assets/css/ScheduledEvents.css";
import React, { useState } from "react";
import {
  AutoGraph,
  Check,
  ChevronRight,
  Delete,
  ExpandMore,
} from "@mui/icons-material";
import HourFormat from "../../util/hourFormat";
import Error from "../Error";
import {
  getBookingAnswers,
  getBookings,
  getInviteeQuestions,
} from "../../graphql/querys";
import {
  getBookingAnswersBased,
  REMOVE_BOOKINGS,
  SEND_EMAIL_MUTATION,
  updateBookings,
} from "../../graphql/mutations";

function ScheduledEvents(props) {
  const isSmallScreen = useMediaQuery("(max-width:700px)");
  const [value, setValue] = React.useState(0);
  const [removeBooking] = useMutation(REMOVE_BOOKINGS);
  const [updateBooking] = useMutation(updateBookings);
  const [getBased] = useMutation(getBookingAnswersBased);
  const [sendEmail] = useMutation(SEND_EMAIL_MUTATION);
  const pendingToNull = (id, status) => {
    updateBooking({ variables: { id: parseInt(id), status } })
      .then((val) => {
        refetch();
        console.log(val);
      })
      .catch((val) => console.log(val));
  };
  const deleteBooking = (id) => {
    removeBooking({ variables: { id: parseInt(id) } }).then((val) => {
      refetch();
      return val;
    });
  };
  React.useEffect(() => {
    // Parse the query string from the URL and set the initial tab value
    const searchParams = new URLSearchParams(window.location.search);
    const queryParam = searchParams.get("scheduletab");
    if (queryParam) {
      const index = parseInt(queryParam);
      if (!isNaN(index) && index - 1 >= 0 && index - 1 < 2) {
        setValue(index - 1);
      }
    }
  }, []);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("scheduletab", newValue + 1);
    const newUrl = window.location.pathname + "?" + searchParams.toString();
    window.history.pushState(null, null, newUrl);
  };
  function TabPanel(e) {
    const { children, value, index, ...other } = e;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {e.display}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [input, setInput] = useState("");
  const { loading, error, data, refetch } = useQuery(getBookings, {
    variables: {
      userId: props.currentUser.userId, // Replace with the user ID you want to filter by
    },
  });
  const {
    loading: answersLoading,
    error: answersError,
    data: answersData,
    refetch: answersRefetch,
  } = useQuery(getBookingAnswers, {
    variables: {
      userId: props.currentUser.userId, // Replace with the user ID you want to filter by
    },
  });

  const {
    loading: questionLoading,
    error: questionError,
    data: questionData,
    refetch: questionRefetch,
  } = useQuery(getInviteeQuestions, {
    variables: {
      userId: props.currentUser.userId, // Replace with the user ID you want to filter by
    },
  }); // Replace bookingId with the actual id of the booking
  function findEmail(bookingId) {
    // Find the booking
    const booking = data.getBookings.flat().find((val) => val.id == bookingId);
    if (booking) {
      // Find the email question's id
      const emailQuestionId = questionData.getInviteeQuestions.find(
        (question) =>
          question.title.toLowerCase() === "email" &&
          question.eventId.toString() === booking.eventId.toString()
      )?.id;
      // Find the booking's answers
      const bookingAnswers = answersData.getBookingAnswers.filter(
        (answer) => answer.bookingId == bookingId
      );
      const groupedAnswers = bookingAnswers.reduce((acc, cur) => {
        const questionId = cur.questionId;
        if (acc[questionId]) {
          acc[questionId].push(cur.answer);
        } else {
          acc[questionId] = [cur.answer];
        }
        return acc;
      }, {});

      // Get the email
      const emailAnswer = groupedAnswers[emailQuestionId]?.join(", ");

      return emailAnswer;
    }
    return null;
  }
  const handleCancel = (val, message) => {
    // perform the cancel action here
    setSelected(-1);
    setShowCancelModal(false);
    val.map((val) => {
      sendEmail({
        variables: {
          to: findEmail(val.id),
          subject: "Cancellation Email",
          text:
            "Your meeting with " +
            props.currentUser.username +
            " has been cancelled. " +
            (message ? '\n\n"' + message + '".' : ""),
        },
      });
    });
    val?.length
      ? val.map((vall) =>
          removeBooking({ variables: { bookingId: parseInt(vall.id) } }).then(
            (res) => {
              refetch();
            }
          )
        )
      : removeBooking({ variables: { bookingId: parseInt(val.id) } }).then(
          (res) => {
            refetch();
          }
        );
  };

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selected, setSelected] = useState(-1);
  const [currentData, setCurrentData] = useState([]);
  const [name, setName] = useState([]);
  if (loading || answersLoading || questionLoading) return "loading";
  if (error || answersError || questionError) {
    return <Error />;
  }
  const CancelModal = () => {
    var group = currentData?.length;
    function g(e, f) {
      return group ? e : f ? f : "";
    }
    const [message, setMessage] = useState("");
    return (
      <Modal open={showCancelModal} onClose={() => setShowCancelModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
            outline: "none",
            maxWidth: "300px",
          }}
        >
          <h2>Cancel Booking{g("s")}</h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {" "}
            <div
              style={{
                height: "30px",
                display: "flex",
                alignItems: "center",
                gap: "5%",
                marginTop: "10px",
              }}
            >
              <Typography>
                {g(
                  group && dat(currentData[0])?.name,
                  name.length && dat(currentData)?.name
                )}
              </Typography>
            </div>
            <Typography>
              {g(
                group &&
                  name?.map(
                    (val, ind) => val + (ind == name?.length - 1 ? "." : ", ")
                  ),
                name
              )}
            </Typography>{" "}
            <Typography style={{ height: "25px" }}>
              {name.length &&
                format(
                  new Date(currentData?.time || currentData[0]?.time),
                  HourFormat()
                ).toLowerCase() +
                  " - " +
                  format(
                    addMinutes(
                      new Date(currentData?.time || currentData[0]?.time),
                      dat(g(currentData[0], currentData))?.length
                    ),
                    HourFormat()
                  ).toLowerCase()}
            </Typography>
          </div>
          <Typography style={{ marginTop: "20px" }}>
            Please confirm that you would like to cancel{" "}
            {g("these bookings", "this booking")}. A cancellation email will
            also go out to {g("all")} the invitee
            {g("s")}.
          </Typography>
          <OutlinedInput
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            style={{ borderRadius: "10px", margin: "20px 0" }}
            placeholder="Add an optional message"
            multiline
            minRows={4}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={() => setShowCancelModal(false)}
              sx={{ mr: 2 }}
              style={{ background: "#d9bca9" }}
            >
              Nevermind
            </Button>
            <Button
              variant="outlined"
              onClick={() => handleCancel(currentData, message)}
            >
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  };
  const bookingsMap = new Map();
  const dat = (val) => {
    var ret = props.data.find((e) => {
      return parseInt(e.id) == val.eventId;
    }) || { color: "black" };
    return ret;
  };
  const sorted = [...data.getBookings]
    .sort((a, b) => new Date(a.time) - new Date(b.time))
    .filter((val) => val.status != "deleted");

  // separate past and upcoming bookings based on time
  const now = new Date();
  const pastt = [];
  const upcomingg = [];
  const pendingg = [];

  sorted.forEach((booking) => {
    const date = new Date(booking.time);
    if (booking.status == "Pending") {
      pendingg.push(booking);
    } else {
      if (date < now) {
        pastt.push(booking);
      } else {
        upcomingg.push(booking);
      }
    }
  });

  // group past bookings by date
  const pastBookingsMap = new Map();
  pastt.forEach((booking) => {
    const date = format(new Date(booking.time), "EEEE, MMMM d, yyyy");
    if (pastBookingsMap.has(date)) {
      pastBookingsMap.get(date).push(booking);
    } else {
      pastBookingsMap.set(date, [booking]);
    }
  });

  // group upcoming bookings by date
  const upcomingBookingsMap = new Map();
  upcomingg.forEach((booking) => {
    const date = format(new Date(booking.time), "EEEE, MMMM d, yyyy");
    if (upcomingBookingsMap.has(date)) {
      upcomingBookingsMap.get(date).push(booking);
    } else {
      upcomingBookingsMap.set(date, [booking]);
    }
  });

  const pendingBookingsMap = new Map();
  pendingg.forEach((booking) => {
    const date = format(new Date(booking.time), "EEEE, MMMM d, yyyy");
    if (pendingBookingsMap.has(date)) {
      pendingBookingsMap.get(date).push(booking);
    } else {
      pendingBookingsMap.set(date, [booking]);
    }
  });

  // convert past bookings map into an array of objects
  const past = Array.from(pastBookingsMap, ([date, bookings]) => ({
    date,
    bookings,
  }));

  // convert upcoming bookings map into an array of objects
  const upcoming = Array.from(upcomingBookingsMap, ([date, bookings]) => ({
    date,
    bookings,
  }));
  const pending = Array.from(pendingBookingsMap, ([date, bookings]) => ({
    date,
    bookings,
  }));
  function text(top, bottom) {
    return (
      <div style={{ height: "50px", textAlign: "left" }}>
        <Typography variant="h6" fontWeight={600}>
          {top}
        </Typography>
        <Typography>{bottom}</Typography>
      </div>
    );
  }
  const Events = (data) => {
    return (
      <div style={{ paddingBottom: "20px" }}>
        {data.data.length ? (
          data.data.map((val, index) =>
            val ? (
              <div>
                <div className="date-header">
                  <Typography>
                    {val.date}
                    <b style={{ margin: "0 20px" }}>
                      {isToday(new Date(val.date)) && "Today"}
                    </b>
                  </Typography>
                </div>
                <div className="">
                  {data.data[index].bookings
                    .filter(
                      (val, indexx, self) =>
                        indexx ===
                        self.findIndex(
                          (t) => t.time === val.time && t.eventId == val.eventId
                        )
                    )
                    .map((val, indexx) => (
                      <>
                        <div
                          className={
                            "bookingBox" +
                            (val.status == "deleted" ? " deleted" : "")
                          }
                          onClick={() =>
                            selected == val.id
                              ? setSelected(-1)
                              : val.status == "deleted"
                              ? () => {}
                              : setSelected(val.id)
                          }
                          style={{
                            borderBottom:
                              selected !== val.id &&
                              indexx == data.data[index].bookings.length - 1 &&
                              "none",
                          }}
                        >
                          {isSmallScreen ? (
                            <>
                              <div
                                className="flexitem"
                                style={{
                                  flex: 2,
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div className="flexitem">
                                  <div
                                    className="circle"
                                    style={{
                                      background: dat(val).color,
                                    }}
                                  ></div>
                                  <Typography style={{ height: "25px" }}>
                                    {format(
                                      new Date(val.time),
                                      HourFormat()
                                    ).toLowerCase() +
                                      " - " +
                                      format(
                                        addMinutes(
                                          new Date(val.time),
                                          dat(val).length
                                        ),
                                        HourFormat()
                                      ).toLowerCase()}
                                  </Typography>{" "}
                                </div>
                                <div>
                                  {
                                    data.data[index].bookings
                                      .filter(
                                        (vall) =>
                                          val.time == vall.time &&
                                          vall.eventId == val.eventId
                                      )
                                      .map((val) => {
                                        return answersData.getBookingAnswers
                                          .filter(
                                            (vall) => vall.bookingId == val.id
                                          )
                                          .reduce((acc, cur) => {
                                            const questionId = cur.questionId;
                                            if (acc[questionId]) {
                                              acc[questionId].push(cur.answer);
                                            } else {
                                              acc[questionId] = [cur.answer];
                                            }
                                            acc["bookingId"] = val;
                                            return acc;
                                          }, {});
                                      })
                                      .map((groupedAnswers) => {
                                        const nameQuestionId =
                                          questionData.getInviteeQuestions.find(
                                            (question) =>
                                              question.title.toLowerCase() ===
                                                "name" &&
                                              dat(val).id.toString() ===
                                                question.eventId.toString()
                                          )?.id;
                                        return groupedAnswers[
                                          nameQuestionId
                                        ]?.join(", ");
                                      })[0]
                                  }{" "}
                                  {dat(val)?.eventType == "group" &&
                                  data.data[index].bookings.filter(
                                    (vall) =>
                                      val.time == vall.time &&
                                      vall.eventId == val.eventId
                                  ).length - 1
                                    ? "+" +
                                      (data.data[index].bookings.filter(
                                        (vall) =>
                                          val.time == vall.time &&
                                          vall.eventId == val.eventId
                                      ).length -
                                        1) +
                                      " more"
                                    : ""}
                                </div>
                                <div>
                                  Event: {dat(val).name}
                                  {dat(val)?.eventType == "group" && "(Group)"}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flexitem">
                                <div
                                  className="circle"
                                  style={{
                                    background: dat(val).color,
                                  }}
                                ></div>
                                <Typography style={{ height: "25px" }}>
                                  {format(
                                    new Date(val.time),
                                    HourFormat()
                                  ).toLowerCase() +
                                    " - " +
                                    format(
                                      addMinutes(
                                        new Date(val.time),
                                        dat(val).length
                                      ),
                                      HourFormat()
                                    ).toLowerCase()}
                                </Typography>
                              </div>
                              <div className="flexitem center column">
                                <div>
                                  {
                                    data.data[index].bookings
                                      .filter(
                                        (vall) =>
                                          val.time == vall.time &&
                                          vall.eventId == val.eventId
                                      )
                                      .map((val) => {
                                        return answersData.getBookingAnswers
                                          .filter(
                                            (vall) => vall.bookingId == val.id
                                          )
                                          .reduce((acc, cur) => {
                                            const questionId = cur.questionId;
                                            if (acc[questionId]) {
                                              acc[questionId].push(cur.answer);
                                            } else {
                                              acc[questionId] = [cur.answer];
                                            }
                                            acc["bookingId"] = val;
                                            return acc;
                                          }, {});
                                      })
                                      .map((groupedAnswers) => {
                                        const nameQuestionId =
                                          questionData.getInviteeQuestions.find(
                                            (question) =>
                                              question.title.toLowerCase() ===
                                                "name" &&
                                              dat(val).id.toString() ===
                                                question.eventId.toString()
                                          )?.id;
                                        return groupedAnswers[
                                          nameQuestionId
                                        ]?.join(", ");
                                      })[0]
                                  }{" "}
                                  {dat(val)?.eventType == "group" &&
                                  data.data[index].bookings.filter(
                                    (vall) =>
                                      val.time == vall.time &&
                                      vall.eventId == val.eventId
                                  ).length - 1
                                    ? "+" +
                                      (data.data[index].bookings.filter(
                                        (vall) =>
                                          val.time == vall.time &&
                                          vall.eventId == val.eventId
                                      ).length -
                                        1) +
                                      " more"
                                    : ""}
                                </div>
                                <div>
                                  Event: {dat(val).name}
                                  {dat(val)?.eventType == "group" && "(Group)"}
                                </div>
                              </div>
                            </>
                          )}
                          {val.status == "deleted" ? (
                            <div
                              className="flexitem center"
                              style={{ alignItems: "center" }}
                            >
                              <p style={{ color: "red" }}>Canceled</p>
                            </div>
                          ) : (
                            <div
                              className="flexitem center"
                              style={{ alignItems: "center" }}
                            >
                              Details{" "}
                              {selected == val.id ? (
                                <ExpandMore />
                              ) : (
                                <ChevronRight />
                              )}
                            </div>
                          )}
                        </div>
                        {selected == val.id && (
                          <div
                            className="bookingBox nohover"
                            style={{
                              minHeight: "300px",
                              flexDirection: isSmallScreen && "column",
                              borderBottom:
                                indexx ==
                                  data.data[index].bookings.length - 1 &&
                                "none",
                            }}
                          >
                            <div
                              className="flexitem column"
                              style={{ display: isSmallScreen && "none" }}
                            >
                              {value == 1 ? (
                                <>
                                  <Button
                                    style={{
                                      border: "1px solid #19c219",
                                      borderRadius: "25px",
                                      background: "white",
                                      color: "#19c219",
                                      padding: "25px",
                                      height: "40px",
                                      display: value == 2 && "none",
                                      maxWidth: "170px",
                                    }}
                                    disableRipple
                                    focusRipple
                                    onClick={() => pendingToNull(val.id, "")}
                                    startIcon={<Check />}
                                  >
                                    Approve
                                  </Button>
                                  <Button
                                    style={{
                                      border: "1px solid rgb(219, 68, 55)",
                                      borderRadius: "25px",
                                      background: "white",
                                      color: "rgb(219, 68, 55)",
                                      padding: "25px",
                                      height: "40px",
                                      display: value == 2 && "none",
                                      maxWidth: "170px",
                                    }}
                                    disableRipple
                                    focusRipple
                                    className="hovered"
                                    onClick={() => deleteBooking(val.id)}
                                    startIcon={<Delete />}
                                  >
                                    Decline
                                  </Button>
                                </>
                              ) : (
                                <>
                                  <Button
                                    onClick={() => {
                                      setName([]);
                                      var final = [];
                                      (
                                        data.data[index].bookings.filter(
                                          (vall) =>
                                            val.time == vall.time &&
                                            vall.eventId == val.eventId
                                        ) || [val]
                                      ).map((val) =>
                                        getBased({
                                          variables: {
                                            bookingId: parseInt(val.id),
                                            questionName: "Name",
                                          },
                                        })
                                          .then((res) => {
                                            final.push(
                                              res.data.getBookingAnswersBased
                                                .answer
                                            );
                                          })
                                          .catch((res) =>
                                            console.log({
                                              bookingId: val.id,
                                              questionName: "Name",
                                            })
                                          )
                                      );
                                      setName(final);
                                      setShowCancelModal(true);
                                      setCurrentData(
                                        data.data[index].bookings.filter(
                                          (vall) =>
                                            val.time == vall.time &&
                                            vall.eventId == val.eventId
                                        ) || val
                                      );
                                    }}
                                    style={{
                                      border: "1px solid rgb(219, 68, 55)",
                                      borderRadius: "25px",
                                      background: "white",
                                      color: "rgb(219, 68, 55)",
                                      padding: "25px",
                                      height: "40px",
                                      display: value == 2 && "none",
                                      maxWidth: "170px",
                                    }}
                                    disableRipple
                                    focusRipple
                                    className="hovered"
                                    startIcon={<Delete />}
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    href={"/app/analytics?event=" + dat(val).id}
                                    style={{
                                      border: "1px solid #0000EE",
                                      borderRadius: "25px",
                                      background: "white",
                                      color: "#0000EE",
                                      padding: "25px",
                                      height: "40px",
                                      maxWidth: "170px",
                                      display:
                                        props.currentUser.role.toLowerCase() ==
                                          "starter" && "none",
                                    }}
                                    disableRipple
                                    focusRipple
                                    className="hovered"
                                    startIcon={<AutoGraph />}
                                  >
                                    Analytics
                                  </Button>
                                </>
                              )}
                            </div>
                            <div
                              className="flexitem center column"
                              style={{
                                flex: dat(val)?.eventType == "group" ? 3 : 2,
                                justifyContent: "space-between",
                              }}
                            >
                              {" "}
                              <Button
                                onClick={() => {
                                  setName([]);
                                  var final = [];
                                  (
                                    data.data[index].bookings.filter(
                                      (vall) =>
                                        val.time == vall.time &&
                                        vall.eventId == val.eventId
                                    ) || [val]
                                  ).map((val) =>
                                    getBased({
                                      variables: {
                                        bookingId: parseInt(val.id),
                                        questionName: "Name",
                                      },
                                    })
                                      .then((res) => {
                                        final.push(
                                          res.data.getBookingAnswersBased.answer
                                        );
                                      })
                                      .catch((res) =>
                                        console.log({
                                          bookingId: val.id,
                                          questionName: "Name",
                                        })
                                      )
                                  );
                                  setName(final);
                                  setShowCancelModal(true);
                                  setCurrentData(
                                    data.data[index].bookings.filter(
                                      (vall) =>
                                        val.time == vall.time &&
                                        vall.eventId == val.eventId
                                    ) || val
                                  );
                                }}
                                style={{
                                  border: "1px solid rgb(219, 68, 55)",
                                  borderRadius: "25px",
                                  background: "white",
                                  color: "rgb(219, 68, 55)",
                                  padding: "25px",
                                  height: "30px",
                                  maxWidth: "30px",
                                  display: !isSmallScreen && "none",
                                }}
                                disableRipple
                                focusRipple
                                className="hovered"
                              >
                                <Delete />
                              </Button>
                              <div className="flex">
                                <div
                                  style={
                                    dat(val)?.eventType !== "group"
                                      ? {
                                          justifyContent: "space-around",
                                          display: "flex",
                                          flexDirection: "column",
                                          width: "100%",
                                        }
                                      : { width: "100%" }
                                  }
                                >
                                  {dat(val)?.eventType == "group" ? (
                                    <TableContainer
                                      component={Paper}
                                      style={{ width: "100%" }}
                                    >
                                      <Table
                                        sx={{ width: "100%" }}
                                        aria-label="simple table"
                                      >
                                        <TableHead>
                                          <TableRow>
                                            {questionData.getInviteeQuestions
                                              .filter(
                                                (vall) =>
                                                  vall.eventId == dat(val)?.id
                                              )
                                              .map((val) => (
                                                <TableCell>
                                                  {val.title}
                                                </TableCell>
                                              ))}
                                            <TableCell align="right"></TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {data.data[index].bookings
                                            .filter(
                                              (vall) =>
                                                val.time == vall.time &&
                                                vall.eventId == val.eventId
                                            )
                                            .map((val) => {
                                              return answersData.getBookingAnswers
                                                .filter(
                                                  (vall) =>
                                                    vall.bookingId == val.id
                                                )
                                                .reduce((acc, cur) => {
                                                  const questionId =
                                                    cur.questionId;
                                                  if (acc[questionId]) {
                                                    acc[questionId].push(
                                                      cur.answer
                                                    );
                                                  } else {
                                                    acc[questionId] = [
                                                      cur.answer,
                                                    ];
                                                  }
                                                  acc["bookingId"] = val;
                                                  return acc;
                                                }, {});
                                            })
                                            .map((groupedAnswers, ind, arr) => (
                                              <TableRow
                                                style={{ textAlign: "left" }}
                                                sx={{
                                                  "&:last-child td, &:last-child th":
                                                    { border: 0 },
                                                }}
                                              >
                                                {Object.keys(
                                                  groupedAnswers
                                                ).map(
                                                  (questionId, ind2, arr2) => {
                                                    if (
                                                      groupedAnswers[questionId]
                                                        ?.length
                                                    ) {
                                                      var final =
                                                        questionData.getInviteeQuestions.filter(
                                                          (vall) =>
                                                            vall.eventId ==
                                                            dat(val)?.id
                                                        ).length -
                                                        (Object.keys(
                                                          groupedAnswers
                                                        ).length -
                                                          1);
                                                      var last =
                                                        arr2.length - 2 ==
                                                          ind2 && final > 0;
                                                      return (
                                                        <>
                                                          {groupedAnswers[
                                                            questionId
                                                          ] !== "" ? (
                                                            <TableCell align="left">
                                                              {groupedAnswers[
                                                                questionId
                                                              ].join(", ")}
                                                            </TableCell>
                                                          ) : (
                                                            <TableCell className="font2">
                                                              none
                                                            </TableCell>
                                                          )}
                                                          {last &&
                                                            Array.from(
                                                              Array(
                                                                final
                                                              ).keys()
                                                            ).map((val) => (
                                                              <TableCell className="font2">
                                                                none
                                                              </TableCell>
                                                            ))}
                                                        </>
                                                      );
                                                    }
                                                  }
                                                )}
                                                {/* <TableCell
                                                  component="th"
                                                  scope="row"
                                                >
                                                  {row.name}
                                                </TableCell>
                                                <TableCell align="right">
                                                  {row.email}
                                                </TableCell>
                                                <TableCell align="right">
                                                  Location not given
                                                </TableCell>
                                                <TableCell align="right">
                                                  Pacific Time - US &
                                                  Canada(Default)
                                                </TableCell>
                                                <TableCell align="right">
                                                  <Typography
                                                    style={{ opacity: "50%" }}
                                                  >
                                                    <i>
                                                      Created{" "}
                                                      {isToday(
                                                        new Date(
                                                          parseInt(
                                                            val.createdAt
                                                          )
                                                        )
                                                      )
                                                        ? "Today"
                                                        : format(
                                                            new Date(
                                                              parseInt(
                                                                val.createdAt
                                                              )
                                                            ),
                                                            "MMMM d, yyyy"
                                                          )}
                                                    </i>
                                                  </Typography>
                                                </TableCell> */}
                                                <TableCell align="right">
                                                  <IconButton
                                                    style={{ display: "flex" }}
                                                    onClick={() => {
                                                      setName([]);
                                                      var final = [];
                                                      // console.log( (
                                                      //   groupedAnswers[
                                                      //     "bookingId"
                                                      //   ]
                                                      // ));
                                                      [
                                                        groupedAnswers[
                                                          "bookingId"
                                                        ],
                                                      ].map((val) =>
                                                        getBased({
                                                          variables: {
                                                            bookingId: parseInt(
                                                              val.id
                                                            ),
                                                            questionName:
                                                              "Name",
                                                          },
                                                        })
                                                          .then((res) => {
                                                            final.push(
                                                              res.data
                                                                .getBookingAnswersBased
                                                                .answer
                                                            );
                                                          })
                                                          .catch((res) =>
                                                            console.log({
                                                              bookingId: val.id,
                                                              questionName:
                                                                "Name",
                                                            })
                                                          )
                                                      );
                                                      setName(final);
                                                      setShowCancelModal(true);
                                                      setCurrentData([
                                                        groupedAnswers[
                                                          "bookingId"
                                                        ],
                                                      ]);
                                                    }}
                                                  >
                                                    <Delete />
                                                  </IconButton>
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  ) : (
                                    <>
                                      {questionData.getInviteeQuestions
                                        .filter(
                                          (vall) => vall.eventId == dat(val)?.id
                                        )
                                        .map((questionVal) => {
                                          return text(
                                            questionVal.title,
                                            answersData.getBookingAnswers
                                              .filter((answerVal) => {
                                                return (
                                                  answerVal.bookingId ==
                                                    val.id &&
                                                  answerVal.questionId ==
                                                    questionVal.id
                                                );
                                              })
                                              .map((val, ind) => {
                                                return (
                                                  (ind ? ", " : "") + val.answer
                                                );
                                              })
                                          );
                                        })}
                                      <div>
                                        {text(
                                          "Invitee Time Zone",
                                          val.timezone
                                        )}
                                      </div>
                                      <div>
                                        <Typography style={{ opacity: "50%" }}>
                                          <i>
                                            Created{" "}
                                            {isToday(
                                              new Date(parseInt(val.createdAt))
                                            )
                                              ? "Today"
                                              : format(
                                                  new Date(
                                                    parseInt(val.createdAt)
                                                  ),
                                                  "MMMM d, yyyy"
                                                )}
                                          </i>
                                        </Typography>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                </div>
              </div>
            ) : (
              ""
            )
          )
        ) : (
          <div
            style={{
              height: "157px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography>No {data.type} events</Typography>
          </div>
        )}
      </div>
    );
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      {" "}
      <CancelModal isOpen={showCancelModal} />
      <div
        style={{
          maxWidth: "1000px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          margin: "20px 0",
        }}
      >
        <Card
          style={{
            maxWidth: "1000px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="bot">
            {" "}
            <Box
              sx={{
                width: "100%",
                padding: "0 20px",
                paddingTop: "10px",
              }}
            >
              <Box>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Upcoming" {...a11yProps(0)} />
                  <Tab label="Pending" {...a11yProps(1)} />
                  <Tab label="Past" {...a11yProps(2)} />
                </Tabs>
              </Box>
            </Box>
          </div>{" "}
          <TabPanel
            value={value}
            index={0}
            display={<Events type="upcoming" data={upcoming} />}
          ></TabPanel>
          <TabPanel
            value={value}
            index={1}
            display={<Events type="pending" data={pending} />}
          ></TabPanel>
          <TabPanel
            value={value}
            index={2}
            display={<Events type="past" data={past} />}
          ></TabPanel>
        </Card>
      </div>
    </div>
  );
}

export default ScheduledEvents;
